var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flip-card"},[_c('div',{staticClass:"flip-card__inner"},[_c('div',{staticClass:"flip-card__front"},[_vm._t("front")],2),_c('div',{staticClass:"flip-card__back"},[_vm._t("back")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }